import React, { Component } from "react";
import Typo from "@material-ui/core/Typography";
import '../galleryStyles.scss';

class AboutUs extends Component {
  render() {
    return (
      <div className="row mt-5 p-5 fadeUpAn">
        <div className="col-12 p-3 text-center">
          <Typo variant="h2" className="font-weight-bold text-center">
            درباره ما
          </Typo>
        </div>
        <div className="col-md-4 p-3 mt-5">
          <Typo variant="body2" className="text-justify rtl">
            در گفتگو کودکان زندگی کردن را می آموزند ! گفتگو، خانه ای امن برای
            کودکان، والدین و مربیان است. ما با هم و در کنار هم، برای پرورش نسلی
            سالم، خلاق و بانشاط تلاش می کنیم. در گفتگو، رابطه ای تنگاتنگ بین
            «آموزش» و «پرورش» برقرار است و همانقدر که به یادگیری مهارتهای شناختی
            کودک اهمیت می دهیم به پرورش روان کودک هم توجه داریم. اینجا خانه دوم
            کودکان است که در آن یاد می گیرند که به هم عشق بورزند، با هم گفتگو
            کنند، حل مساله داشته باشند، با هم مشارکت کنند و خلاق باشند.
          </Typo>
        </div>
        <div className="col-4"></div>
      </div>
    );
  }
}

export default AboutUs;
